<template>
  <Teleport to="body">
    <div class="vt-toast-container" aria-live="polite">
      <TransitionGroup name="vt-toast">
        <div
          v-for="toast in toastStore.toasts"
          :key="toast.id"
          class="vt-toast"
          role="status"
        >
          {{ toast.message }}
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>


<script setup lang="ts">
  // library imports

  // local imports
  import { useToastStore } from '@/stores/toastStore';

  // library components

  // local components

  // types

  ////////////////////////////////
  // props

  ////////////////////////////////
  // emits

  ////////////////////////////////
  // data

  const toastStore = useToastStore();

  ////////////////////////////////
  // computed data

  ////////////////////////////////
  // event handlers

  ////////////////////////////////
  // methods

  ////////////////////////////////
  // watchers

  ////////////////////////////////
  // lifecycle events
</script>


<style lang="scss" scoped>
  .vt-toast-container {
    position: fixed;
    bottom: 24px;
    right: 24px;
    z-index: 400;
    display: flex;
    flex-direction: column;
    gap: 8px;
    pointer-events: none;
  }

  .vt-toast {
    background: var(--vt-color-surface);
    border: 1px solid var(--vt-color-border);
    border-radius: var(--vt-radius);
    box-shadow: var(--vt-shadow-xl);
    padding: 10px 16px;
    font-family: var(--vt-font-sans);
    font-size: var(--vt-font-size-xl);
    color: var(--vt-color-text);
    white-space: nowrap;
  }

  .vt-toast-enter-active,
  .vt-toast-leave-active {
    transition: opacity 0.18s ease, transform 0.18s ease;
  }

  .vt-toast-enter-from,
  .vt-toast-leave-to {
    opacity: 0;
    transform: translateY(8px);
  }
</style>
